// hooks/usePopupManager.js
import { useState } from 'react'

const usePopupManager = () => {
  const [popupContent, setPopupContent] = useState(null) // Almacena el contenido del popup
  const [loadPopUpState, setLoadPopUpState] = useState(false)
  const openPopup = (content) => {
    setPopupContent(content) // Abre el popup con el contenido proporcionado
  }

  const closePopup = () => {
    setPopupContent(null) // Cierra el popup
  }

  const switchForm = (newForm) => {
    setPopupContent(newForm) // Cambia el contenido del popup
  }

  const loadPopupToggle = (load: boolean) => {
    setLoadPopUpState(load)
  }

  return {
    popupContent,
    openPopup,
    closePopup,
    switchForm,

    loadPopUpState,
    loadPopupToggle
  }
}

export default usePopupManager
